export default __webpack_public_path__ + "static/media/undraw_shopping_app_flsj.a9d0587a.svg";